export default "__VITE_ASSET__BRBhebxp__";